export default class Timer {
	segments = []

	start() {
		const last = this.segments[this.segments.length - 1]
		if (last && !last.stop) return
		this.segments.push({ start: new Date() })
	}

	stop() {
		const last = this.segments[this.segments.length - 1]
		if (last && !last.stop) last.stop = new Date()
	}

	getTimes() {
		let start
		let stop
		let accumulated = 0

		this.segments.forEach(x => {
			if (!start) start = x.start
			stop = x.stop || new Date()
			accumulated += stop - x.start
		})

		if (start) {
			stop = stop || new Date()
			const elapsed = stop - start
			return { start, stop, accumulated, elapsed }
		}
	}
}



// WEBPACK FOOTER //
// ./../jump-common/timers/Timer.js